import { RouteParam } from "../../../routes";
import items_routes from "./items_routes";
import item_unit_routes from "./items_unit_routes";
import inventory_bucket_routes from "./warehouse_groups";
import cost_center_routes from "./cost_center_routes";
import stock_journal_transfer_routes from "./stock_transfer_routes";
import stock_outward_routes from "./stock_outward_routes";
import ndp_routes from "./npd_routes";
import transform_routes from "./transform_routes";

const procurement_inventory_routes: RouteParam[] = [
  ...items_routes,
  ...inventory_bucket_routes,
  ...item_unit_routes,
  ...cost_center_routes,
  ...stock_journal_transfer_routes,
  ...stock_outward_routes,
  ...ndp_routes,
  ...transform_routes,
];

export default procurement_inventory_routes;
